// hooks/useCurrentUser.ts
// Reads current user info from the JWT stored in localStorage.
// Returns null if no token or token is malformed.
import { getToken } from '@/lib/api'

export interface CurrentUser {
  id: number
  role: string
  email: string
  companyId: number
}

export function useCurrentUser(): CurrentUser | null {
  const token = getToken()
  if (!token) return null
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return {
      id: payload.uid ?? payload.user_id,
      role: payload.role ?? 'viewer',
      email: payload.email ?? '',
      companyId: payload.company_id ?? 0,
    }
  } catch {
    return null
  }
}

export function canDelete(user: CurrentUser | null): boolean {
  return ['admin', 'manager'].includes(user?.role ?? '')
}

export function canWrite(user: CurrentUser | null): boolean {
  return ['admin', 'manager', 'member'].includes(user?.role ?? '')
}
